"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODERN_BROWSERS = exports.ALL_SUPPORTED_BROWSERS = void 0;
exports.ALL_SUPPORTED_BROWSERS = [
    'last 3 Chrome versions',
    'last 3 Firefox versions',
    'last 3 Safari versions',
    'last 3 Edge versions',
    'ie 11',
];
exports.MODERN_BROWSERS = [
    'last 1 Chrome versions',
    'last 1 Firefox versions',
    'last 1 Safari versions',
    'last 1 Edge versions',
];
//# sourceMappingURL=browserlists.js.map